<template >
  <div>
      <h1> Component loaded</h1>
  </div>
</template>

<script>

export default {
  name: "FlightResult",

};
</script>
<style scoped>
.bar label {
    margin-top: -38px;}
    
@media only screen and (max-width: 750px) {
  .avail-container {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .filter-sidebar {
    display: none !important;
  }
}
.margin_container_hf{
  margin-top: 125px;
  padding: 20px 70px;
}
.filter-sidebar {
  flex: 0 0 27%;
  max-width: 27%;
}

.avail-container {
  flex: 0 0 73%;
  max-width: 73%;
}
.flight_title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}
.flight_title h2 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: -1px;
  font-size: 19px;
  margin-bottom: 0;
  margin-top: 0;
}
.flight_title h2 span {
  color: #00c3e1;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>